import React from 'react';
import { SBB, Directions } from '../Icons/CustomIcons';

export const MapsButton = ({ href }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="activity-detail-action-btn activity-detail-action-btn--maps"
  >
    <Directions size={26} /> Karte öffnen
  </a>
);

export const SBBButton = ({ href }) => href ? (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="activity-detail-action-btn activity-detail-action-btn--sbb"
  >
    <SBB size={26} /> In SBB App öffnen
  </a>
) : null;
